import { Component, Input, OnInit } from '@angular/core';

import { environment } from '@unico-people/ongoing-dashboard/enviroment';

@Component({
  selector: 'up-feature-img-cloud',
  templateUrl: './feature-img-cloud.component.html',
  styleUrls: ['./feature-img-cloud.component.scss']
})
export class FeatureImgCloudComponent implements OnInit {
  @Input() path: string;
  @Input() width: string;
  @Input() height: string;
  @Input() application: string;
  @Input() quality = '50';
  source: string;

  ngOnInit(): void {
    this.source = `${environment.cdn_url}/t/${this.width}x${this.height},q${
      this.quality
    }/${this.path}`;
  }

  handlerError(): void {
    this.source = '/assets/images/ico-avatar.svg';
  }
}
